//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data: function data() {
        return {
            importFile: false,
            validationResults: {
                isValidColumns: [],
                isValidChargeCodes: []
            },
            hasRunValidationCheck: false,
            property: {
                createCharge: false
            },
            processingImport: false,
            importProgress: {},
            importFinished: false,
            proceedWithoutRentRoll: false
        };
    },


    methods: {
        validate: function validate() {
            var _this = this;

            var data = new FormData(document.querySelector('.import-form'));

            axios.post('/prototype/properties/property-import', data).then(function (response) {
                _this.validationResults = response.data;
                _this.hasRunValidationCheck = true;
            });
        },
        setupWithoutRentRoll: function setupWithoutRentRoll() {
            this.hasRunValidationCheck = true;
            this.proceedWithoutRentRoll = true;
        },
        setFile: function setFile() {
            this.importFile = true;
            this.hasRunValidationCheck = false;
        },
        process: function process() {
            var _this2 = this;

            var data = new FormData(document.querySelector('.import-form'));
            data.append('createCharges', this.property.createCharge);
            axios.post('/prototype/properties/property-import/final', data).then(function (response) {
                if (!_this2.proceedWithoutRentRoll) {
                    _this2.processingImport = true;
                    var interval = window.setInterval(function () {
                        axios.post('/prototype/properties/property-import/status', data).then(function (response) {
                            if (response.data != "") {
                                _this2.importProgress = response.data;
                                if (response.data.size === 0) {
                                    window.clearInterval(interval);
                                    _this2.importFinished = true;
                                    _this2.processingImport = false;
                                }
                            }
                        });
                    }, 3000);
                } else {
                    _this2.importFinished = true;
                    _this2.processingImport = false;
                }
            });
        }
    },

    computed: {
        isValidUpload: function isValidUpload() {
            return this.hasRunValidationCheck && this.validationResults.isValidColumns.length === 0 && this.validationResults.isValidChargeCodes.length === 0 || this.proceedWithoutRentRoll;
        }
    }

};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/property/ImportPropertyWizard.vue
// module id = 6APj
// module chunks = 0 1